import m from "../../geodata/es2015/channelIslandsHigh";
window.am4geodata_channelIslandsHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/channelIslandsHigh.js
// module id = null
// module chunks = 